import styled from 'styled-components';

export const DeliveryConditionsContainerBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

export const DeliveryConditionsItemContainer = styled.div`
  min-width: 12.5rem;

  & > .description {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
  }
`;

export const DeliveryConditionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;

  & > div.block {
    min-width: 12.5rem;

    &.receipt-time {
      min-width: 19rem;
      margin-right: 10%;
    }

    display: flex;
    flex-direction: column;

    & > .description {
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.colors.grayDark4};
      font-weight: 400;
      font-size: 1rem;
      margin-bottom: 0.25rem;
    }

    & > div.day-and-time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.5rem;
      gap: 1rem;

      & > span {
        font-size: 1rem;
        color: ${({ theme }) => theme.colors.grayDark4};
      }
    }
  }

  &.observations {
    margin-top: 1rem;
  }
`;
